export const TOPIC_STATUS = {
  NOT_STARTED: "NOT_STARTED",
  STARTED: "STARTED",
  COMPLETED: "COMPLETED",
  MASTERED: "MASTERED",
}; // order specific

export const TOOL_STATUS = {
  NOT_STARTED: "NOT_STARTED",
  STARTED: "STARTED",
  COMPLETED: "COMPLETED",
}; // order specific

export const STEP_STATUS = {
  NOT_STARTED: "NOT_STARTED",
  STARTED: "STARTED",
  COMPLETED: "COMPLETED",
};

export const ARTICLE_TYPE = {
  DOWNLOAD: "Download",
  DOCUMENT: "Document",
  VIDEO: "Video",
}; // resembles doc types template alias

export const INSTANCE_TYPE = {
  THREE_SIXTY: "360",
  PERSONA: "PERSONA",
  STYLE: "STYLE",
  SURVEY: "SURVEY",
  ENGAGE: "ENGAGE",
  TEAM: "TEAM",
};

export const REVIEWER_STATUS = {
  NOT_STARTED: "NOT_STARTED",
  STARTED: "STARTED",
  COMPLETED: "COMPLETED",
  UNKNOWN: "UNKNOWN",
};

export const TEAM_FREE_QUESTION_TYPE = {
  STRENGTH: "STRENGTH",
  WEAKNESS: "WEAKNESS",
};
